import { useTheme, useMediaQuery } from "@material-ui/core";
import { Breakpoint } from "@material-ui/core/styles/createBreakpoints";

export const useMediaBreakpoint = (upDown: "up" | "down", breakpoint: Breakpoint): boolean => {
    const theme = useTheme();
    return useMediaQuery(upDown === "up" ? theme.breakpoints.up(breakpoint) : theme.breakpoints.down(breakpoint));
}